if(typeof BSS_B2B != undefined) {
  if(window.location.pathname.includes("/products")) {
    const targetProduct = document.querySelector(".productView-price");
    if (targetProduct) {
      const mutationObserver = new MutationObserver((recordList, observe) => {
          const productForm = document.querySelector("[bss-b2b-main-product-form]");
          BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
      });
      mutationObserver.observe(targetProduct, { attributes: true });
    }
  }

  setTimeout(() => {
    let quickViewBtn = document.querySelectorAll(".card-quickview");
    if (quickViewBtn.length) {
        for (let i = 0; i < quickViewBtn.length; i++) {
            quickViewBtn[i].onclick = function () {
                setTimeout(function () {
                    document.dispatchEvent(
                        new Event("bss_b2b:QuickviewLoaded")
                    );
                    const variantInput = document.querySelector(
                        "product-form input[name='id']"
                    );
                    const targetProduct =
                        document.querySelector(".productView-price");
                    if (targetProduct) {
                        const mutationObserver = new MutationObserver(
                            (recordList, observe) => {
                                const productForm = document.querySelector(
                                    "[bss-b2b-quickview-product-form]"
                                );
                                BSS_B2B.observer.productSubject.notifyObserver(
                                    "VariantChange",
                                    "VariantSelectChange",
                                    { productForm }
                                );
                            }
                        );
                        mutationObserver.observe(targetProduct, {
                            attributes: true,
                        });
                    }
                }, 1500);
            };
        }
    }
}, 3000);

  
}